<template>
  <w-sliding-popup ref="slidingPopup" type="full" :title="popupInfo.popupTitle + ' 정보'">
    <div slot="content" v-loading="loading">
      <div class="condition-box mr-b25">
        <span class="tit mr-r4">기간선택</span>
        <el-date-picker v-model="dateRange" type="daterange" style="width:225px;"
        :range-separator="defaultDateRangeOptions.rangeSeparator"
        :start-placeholder="defaultDateRangeOptions.startPlaceholder"
        :end-placeholder="defaultDateRangeOptions.endPlaceholder"
        :default-time="defaultDateRangeOptions.defaultTime"
        :picker-options="defaultDateRangeOptions.pickerOptions"
        :clearable="false" />
        <w-device-config-help-button v-if="popupInfo.objCompanyName === 'ciscoSystems' && popupInfo.popupTitle === '장비'"></w-device-config-help-button>
      </div>
      <div class="title-bar">
        <span class="title-h4 dot-title mr-r10">변경 이력</span>
        <el-select v-model="selectedDate" placeholder="변경 이력 선택" @change="changeDate">
          <el-option v-for="changeInfo in changeInfoList" :key="changeInfo.seq" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seq"></el-option>
        </el-select>
      </div>
      <w-interface-change-table v-if="popupInfo.key === 'INTERFACE'" :interface-change-info="interfaceChangeInfo" />
      <el-input v-else type="textarea" :rows="35" v-model="selectedInfo" readonly></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import moment from 'moment';
import { faultCheckItemDefine } from '@/constants/netdevice';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WInterfaceChangeTable from './InterfaceChangeTable';
import WDeviceConfigHelpButton from '../DeviceConfigHelpButton';

export default {
  name: 'WChangeInfoPopup',
  components: {
    WInterfaceChangeTable,
    WDeviceConfigHelpButton,
  },
  props: {
    popupInfo: {
      type: Object,
      default: () => ({
        popupTitle: '',
      }),
    },
  },
  data() {
    return {
      loading: false,
      popupVisible: false,
      dateRange: [],
      selectedDate: null,
      changeInfoList: [],
      params: {},
      selectedInfo: '',
      interfaceChangeInfo: [],
      defaultDateRangeOptions,
    };
  },
  watch: {
    popupInfo: {
      handler(val) {
        this.params.itemId = val.key;
        this.params.objId = val.objId;
        this.params.requestKey = (val.key === faultCheckItemDefine.CONFIG || val.key === faultCheckItemDefine.ROUTING) ? val.key.toLowerCase() : 'common';

        const endDatetime = moment(this.popupInfo.checkDatetime).endOf('day');
        const startDatetime = endDatetime.clone().subtract(14, 'days').startOf('day');
        this.dateRange = [startDatetime.toDate(), endDatetime.toDate()];
      },
    },
    dateRange: {
      handler() {
        this.params.startDatetime = this.dateRange[0].getTime();
        this.params.endDatetime = this.dateRange[1].getTime();
        this.loadchangeInfoList();
      },
    },
  },
  methods: {
    open() {
      // this.popupVisible = true;
      this.$refs.slidingPopup.open();
    },
    /**
     * 상단 날짜 범위 조정 시 데이터 조회
     * @author kimjy
     */
    loadchangeInfoList() {
      this.loading = true;
      netdeviceInfoAPI.getNetdeviceCheckInfo(this.params).then((response) => {
        if (response.data.success) {
          this.setChangeInfo(response.data.data, this.popupInfo.key);
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
          this.clearData();
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
        this.clearData();
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 데이터 조회 후 각 타입에 맞게 데이터 설정
     * @author kimjy
     */
    setChangeInfo(data, key) {
      if (!isEmpty(data)) {
        this.changeInfoList = data;
        this.selectedDate = this.changeInfoList[0].seq;
        if (key === faultCheckItemDefine.INTERFACE) {
          this.interfaceChangeInfo = JSON.parse(data[0].resultStr);
        } else {
          this.selectedInfo = this.changeInfoList[0].resultStr;
        }
      } else {
        this.clearData();
      }
    },
    /**
     * 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearData() {
      this.changeInfoList = [];
      this.interfaceChangeInfo = [];
      this.selectedDate = null;
      this.selectedInfo = '';
    },
    convertCheckDatetime(value) {
      return getDateToString(value);
    },
    /**
     * 날짜 콤보박스에서 날짜 선택
     * @author kimjy
     * @param  {Integer} value seqNumber
     */
    changeDate(value) {
      const index = findIndex(this.changeInfoList, ['seq', value]);
      this.selectedInfo = this.changeInfoList[index].resultStr;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/ChangeInfoPopup.vue